<template>
  <v-container class="" :style="{ marginTop: $vuetify.breakpoint.xs ? '5vh' : '' }">
    <v-breadcrumbs :items="items" large></v-breadcrumbs>
    <v-row v-if="loadingTopics">
      <v-col v-for="(_, index) in loaders" cols="12" md="3" lg="3" :key="index">
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row v-if="loadingTopics" class="my-5">
      <v-col v-for="(_, index) in loaders" cols="12" md="3" lg="3" :key="index">
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <template v-else>
      <template v-if="topics.length">
        <div class="mx-4" v-for="(topic, index) in topics" :key="index">
          <h3 class="primary--text">{{ index + 1 }}.{{ topic.title }}</h3>
          <v-slide-group
            v-if="topic.sub_topic.length"
            v-model="slide"
            class="pa-0"
            active-class="primary"
            show-arrows
          >
            <v-slide-item
              v-for="(subtopic, index) in topic.sub_topic"
              :key="index"
              v-slot="{ active, toggle }"
            >
              <div class="slider-item">
                <v-card
                  :color="active ? 'primary' : 'primary'"
                  class="ma-4"
                  height="200"
                  width="300"
                  @click="toggle"
                  :to="`/learning/${topic.uuid}/${subtopic.uuid}/lessons`"
                  rounded
                >
                  <v-img
                    height="200"
                    :src="
                      subtopic.sub_topic_cover ||
                      `https://via.placeholder.com/300X150/0033AA/?text=${subtopic.title}`
                    "
                  ></v-img>
                </v-card>
                <p
                  class="d-inline-block text-truncate"
                  style="max-width: 150px"
                >
                  {{ subtopic.title }}
                </p>
              </div>
            </v-slide-item>
          </v-slide-group>

          <NoData
            :image="studyImage"
            v-else
            :imageWidth="140"
            title=""
            subtitle="No Subtopics for this subject"
          />
        </div>
      </template>
      <div v-else class="no-items">
        <NoData
          :image="studyImage"
          :imageWidth="200"
          title=""
          :subtitle="`No Topics for ${subjectName}`"
        />
        <v-btn color="primary" link to="/learning" rounded >Back to List</v-btn>
      </div>
    </template>
  </v-container>
</template>

<script>
import NoData from "@/components/NoData.vue";
import studyImage from '@/assets/study.jpg';
export default {
  components: { NoData },
  metaInfo() {
    return {
      studyImage,
      title: `Guiomentor - ${this.subjectName} Topics`,
      url: window.location.href,
      description: `Topics for ${this.subjectName}`,
    };
  },
  data() {
    return {
      gradeName: "",
      subjectName: "",
      subjectId: null,
      gradeId: null,
      items: [],
      loadingTopics: true,
      loaders: [1, 2, 4, 5, 7],
      topics: [],
      slide: null,
    };
  },
  async mounted() {
    const subjectParam = this.$router.history?.current?.params?.subject;
    const gradeParam = this.$router.history?.current?.params?.grade || "";
    const gradeNameArray = gradeParam.split("-");
    this.gradeId = gradeNameArray.pop();
    this.gradeName = gradeNameArray.join(" ");
    const subjectArray = subjectParam.split("-");
    const subjectId = subjectArray.pop();
    this.subjectName = subjectArray.join(" ");
    this.subjectId = subjectId;

    try {
      this.loadingTopics = true;
      const { data } = await this.axios.get(
        `topics/?grade_level=${this.gradeId}&subject=${this.subjectId}&limit=100`
      );
      this.topics = data.results;
       this.items = [
      {
        text: "Learning",
        disabled: false,
        href: "/learning",
      },
      {
        text: data.results[0]?.grade_level?.grade,
        href: "/learning",
      },
      {
        text: data.results[0]?.subject?.name,
        href: "/#",
      },
    ];
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingTopics = false;
    }
  },
};
</script>

<style lang="scss">
.wrapper {
  min-height: 100vh;
}
.slider-item {
  text-align: center;
}
.no-items {
  text-align: center;
}

</style>
